import { isProduction } from '../utils/platform';
import { getQuery } from '../utils/queryUtils';
import { Endpoints, SwapCommendationsResult } from './types';

export class MLDebug {
  static enabled: boolean = false;

  constructor() {
    if (getQuery().get('disableDebug') !== 'true' && !isProduction()) {
      // @ts-ignore
      window.MLDebug = this;
    }
  }

  enable() {
    MLDebug.enabled = true;
  }

  static log(endpoint: string, result: SwapCommendationsResult) {
    if (!MLDebug.enabled) return;
    switch (endpoint) {
      case Endpoints.SWAP_COMMEDATIONS:
        this.printSwapCommedations(result as SwapCommendationsResult);
        break;
      default:
        /* eslint-disable  no-console */

        console.warn('Unknown endpoints', endpoint);
        break;
    }
  }

  private static printSwapCommedations(data: SwapCommendationsResult) {
    if (!data) return;
    const table = data.recommended.map((art, i) => [art, data.scores[i]]);
    console.group();
    console.table(table);
    console.groupEnd();
  }
}
